module.exports = __webpack_public_path__ + "static/media/shattered-glass-right.7b666c95.png";